import { createReducer } from '@reduxjs/toolkit'
import {
  resetFilteredNodes
  resetFilteredRelations
  resetGraphFilters
  resetRelationFilters
  resetTypeFilters
  setActiveFilterTab
  setFilteredNodesByGraph
  setFilteredNodesByOther
  setFilteredNodesByRelation
  setFilteredNodesBySearch
  setFilteredNodesByType
  setFilteredRelationsByKey
  setFilteredRelationsByOther
  setGraphFilters
  setHideNamelessNodeLabels
  setHideRelationLabels
  setRelationFilters
  setShowRelationsAsNodes
  setTypeFilters
  updateGraphFilter
  updateGraphFilters
  updateRelationFilter
  updateRelationFilters
  updateTypeFilter
  updateTypeFilters
} from 'Actions/graphFilter'

initialState = {
  activeFilterTab: "relations"
  graphFilters: {}
  hideNamelessNodeLabels: false
  hideRelationLabels: false
  relationFilters: {}
  showRelationsAsNodes: false
  typeFilters: {}
  filteredRelations: {
    byOther: []
    byKey: []
  }
  filteredNodes: {
    byGraph: []
    byOther: []
    byRelation: []
    bySearch: []
    byType: []
  }
}

export default createReducer(initialState, {
  [resetFilteredNodes]: (state, action) ->
    state.filteredNodes = initialState.filteredNodes
    undefined
  [resetFilteredRelations]: (state, action) ->
    state.filteredRelations = initialState.filterNodesByRelation
    undefined
  [resetGraphFilters]: (state, action) ->
    state.graphFilters = initialState.graphFilters
    undefined
  [resetRelationFilters]: (state, action) ->
    state.relationFilters = initialState.relationFilters
    undefined
  [resetTypeFilters]: (state, action) ->
    state.typeFilters = initialState.typeFilters
    undefined
  [setActiveFilterTab]: (state, action) ->
    state.activeFilterTab = action.payload
    undefined
  [setFilteredNodesByGraph]: (state, action) ->
    state.filteredNodes.byGraph = action.payload
    undefined
  [setFilteredNodesByOther]: (state, action) ->
    state.filteredNodes.byOther = action.payload
    undefined
  [setFilteredNodesByRelation]: (state, action) ->
    state.filteredNodes.byRelation = action.payload
    undefined
  [setFilteredNodesBySearch]: (state, action) ->
    state.filteredNodes.bySearch = action.payload
    undefined
  [setFilteredNodesByType]: (state, action) ->
    state.filteredNodes.byType = action.payload
    undefined
  [setGraphFilters]: (state, action) ->
    state.graphFilters = action.payload
    undefined
  [setHideNamelessNodeLabels]: (state, action) ->
    state.hideNamelessNodeLabels = action.payload
    undefined
  [setHideRelationLabels]: (state, action) ->
    state.hideRelationLabels = action.payload
    undefined
  [setFilteredRelationsByKey]: (state, action) ->
    state.filteredRelations?.byKey = action.payload
    undefined
  [setFilteredRelationsByOther]: (state, action) ->
    state.filteredRelations?.byOther = action.payload
    undefined
  [setRelationFilters]: (state, action) ->
    state.relationFilters = action.payload
    undefined
  [setShowRelationsAsNodes]: (state, action) ->
    state.showRelationsAsNodes = action.payload
    undefined
  [setTypeFilters]: (state, action) ->
    state.typeFilters = action.payload
    undefined
  [updateGraphFilter]: (state, action) ->
    graphFilter = state.graphFilters[action.payload.id]
    graphFilter.enabled = action.payload.enabled
    undefined
  [updateGraphFilters]: (state, action) ->
    state.graphFilters = {
      state.graphFilters...
      action.payload...
    }
    undefined
  [updateRelationFilter]: (state, action) ->
    relationFilter = state.relationFilters[action.payload.key]
    relationFilter.enabled = action.payload.enabled
    undefined
  [updateRelationFilters]: (state, action) ->
    state.relationFilters = {
      state.relationFilters...
      action.payload...
    }
    undefined
  [updateTypeFilter]: (state, action) ->
    typeFilter = state.typeFilters[action.payload.id] or {}
    state.typeFilters[action.payload.id] = {
      typeFilter...
      action.payload...
    }
    undefined
  [updateTypeFilters]: (state, action) ->
    state.typeFilters = {
      state.typeFilters...
      action.payload...
    }
    undefined
})
